module.exports = __webpack_public_path__ + "static/Crowns 1 smile before-e3b788568dc69c77af0d1373ffbcf912.jpg";